import { Box, Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";

import NavigatorCard from "../../components/UI/HomeNavigation/NavigatorCard";
import { INavigationItem } from "../../models/navigation";
import { useExtensionConfigs } from "../../hooks/useExtensionConfigs";
import { Extension } from "../../models/intalled-extensions";
import { Loading, useFetch } from "@4uhub/lib4uhub";
import {
  getTicketAutomationReceivedRule,
  ITicketAutomationReceivedRule,
} from "../../services/tasySchedMenu.service";
import { useNavigate } from "react-router-dom";

const Actions = () => {
  const navigate = useNavigate();

  const { fetchExtensionConfig, loadingExtensionConfigs } =
    useExtensionConfigs();

  const {
    sendRequest: getTicketAutomationReceivedRuleRequest,
    loading: loadingGetTicketAutomationReceivedRule,
  } = useFetch(getTicketAutomationReceivedRule);

  const [mySchedulesRule, setMySchedulesRule] =
    useState<ITicketAutomationReceivedRule | null>(null);

  const items = useMemo(() => {
    const baseItems: INavigationItem[] = [
      {
        name: "page.schedules.home.actions.newSchedule",
        link: "menus",
        onClick() {
          navigate("menus");
        },
        icon: (
          <img
            style={{ height: 75 }}
            src="/actions/default/schedule-add.png"
            alt={"NewSchedule"}
          />
        ),
        isExtensionInstalled: true,
      },
      {
        name: "page.schedules.home.actions.familyGroup",
        link: "/schedule-new/familyGroup",
        onClick() {
          navigate("familyGroup");
        },
        icon: (
          <img
            style={{ height: 75 }}
            src="/actions/default/schedule-group.png"
            alt={"FamilyGroup"}
          />
        ),
        isExtensionInstalled: true,
      },
      {
        name: "page.schedules.home.actions.insurance",
        link: "/schedule-new/insurance",
        onClick() {
          navigate("insurance");
        },
        icon: (
          <img
            style={{ height: 75 }}
            src="/actions/default/schedule-insurance.png"
            alt={"Insurance"}
          />
        ),
        isExtensionInstalled: true,
      },
    ];

    if (mySchedulesRule) {
      baseItems.push({
        name: "page.schedules.home.actions.mySchedules",
        link: "/schedule-new/mySchedules",
        onClick() {
          navigate("mySchedules", {
            state: {
              ticketAutomationReceivedRuleId: mySchedulesRule.id,
              allowedAction:
                mySchedulesRule.ticketAutomationReceivedRuleAllowedAction,
            },
          });
        },
        icon: (
          <img
            style={{ height: 75 }}
            src="/actions/default/schedule.png"
            alt={"Insurance"}
          />
        ),
        isExtensionInstalled: true,
      });
    }

    return baseItems;
  }, [mySchedulesRule, navigate]);

  const fetchGetTicketAutomationReceivedRule = useCallback(async () => {
    const extensionConfig = await fetchExtensionConfig(
      Extension.NEW_SCHEDULE,
      "AutomationCodeForMySchedules",
    );
    const automationCodeForMySchedules = extensionConfig?.value;

    if (!automationCodeForMySchedules) return;

    const { data, success } = await getTicketAutomationReceivedRuleRequest(
      automationCodeForMySchedules,
    );

    if (success && data) {
      setMySchedulesRule(data);
    }
  }, [fetchExtensionConfig, getTicketAutomationReceivedRuleRequest]);

  useEffect(() => {
    fetchGetTicketAutomationReceivedRule();
  }, [fetchGetTicketAutomationReceivedRule]);

  const loading =
    loadingExtensionConfigs || loadingGetTicketAutomationReceivedRule;

  return (
    <Box>
      <Grid
        flexDirection={"row"}
        container
        sx={({ breakpoints }) => ({
          [breakpoints.down("md")]: {
            flexWrap: "nowrap",
            gap: 2,
          },

          [breakpoints.up("md")]: {
            flexWrap: "wrap",
            gap: 3,
          },
          overflowX: "auto",
        })}
      >
        {loading && <Loading />}

        {!loading && (
          <>
            {items.map((item) => (
              <Grid item xs={"auto"} key={item.link}>
                <NavigatorCard {...item} />
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default memo(Actions);
